import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:interests');

export default class InterestsService {
  constructor(aas) {
    this.adApiService = aas;
    this.interests = null;
  }

  loadInterestsFromApi() {
    debug.info('loadInterestsFromApi');
    return this.adApiService.getInterests()
          .then(interests => interests)
          .catch((err) => {
            debug.warn('Could not load Interests', err);
            return [];
          })
          .then((interests) => {
            this.interests = interests;
            return interests;
          });
  }

  getInterests() {
    debug.info('getInterests', this.interests);
    if (this.interests === null) {
      return this.loadInterestsFromApi();
    }

    return new Promise(resolve => resolve(this.interests));
  }
}

Injector.service('interestsService', ['adApiService'], InterestsService);



// WEBPACK FOOTER //
// ./src/services/InterestsService.js